<style>
  .cls-1 {
    stroke: var(--color);
    fill: none;
  }
  .cls-2 {
    fill: var(--color);
  }
  .cls-3,
  .cls-4 {
    fill: none;
    stroke: var(--color);
    stroke-linecap: round;
  }
  .cls-3 {
    stroke-miterlimit: 8.51;
    stroke-width: 26.21px;
  }
  .cls-4 {
    stroke-miterlimit: 8.51;
    stroke-width: 26.21px;
  }
</style>

<svg
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  viewBox="0 0 395.06 367.25"
  >
  <defs>
    <mask
      id="mask"
      x="56.34"
      y="0"
      width="388.95"
      height="634.5"
      maskUnits="userSpaceOnUse"
    />
  </defs>
  <g id="Layer_2" data-name="Layer 2">
    <g id="svg2">
      <g id="g5279">
        <g class="cls-1">
          <circle id="path4642-97" cx="197.53" cy="141.19" r="141.19" />
        </g>
        <g id="g4494">
          <g id="g4445">
            <circle id="path3351" class="cls-2" cx="197.53" cy="141.19" r="30.41" />
            <path id="path4443" class="cls-3" d="M197.53,141.19v213" />
          </g>
          <path id="path4443-5" class="cls-4" d="M197.53,141.19,382,34.71" />
          <g id="g4445-0-9">
            <path id="path4443-5-2" class="cls-4" d="M197.53,141.19,13.11,34.71" />
          </g>
        </g>
      </g>
    </g>
  </g>
</svg>
